import { preselectBusinessPath } from "../../paths";
import { config } from "../../config";
import { mcLeanAxiosInstance } from "../../../components/AxiosInterceptors";

export enum PreselectPayloadType {
  ByAccountReferenceId = "ByAccountReferenceId",
  ByCardProduct = "ByCardProduct",
}

export type PreselectBusinessPayload =
  | { PreselectPayload: PreselectPayloadType.ByAccountReferenceId; accountReferenceId: string }
  | { PreselectPayload: PreselectPayloadType.ByCardProduct; cardProduct: string };

export const preselectBusiness = async (
  payload: PreselectBusinessPayload
): Promise<void> => {
  await mcLeanAxiosInstance.post(
    preselectBusinessPath,
    payload,
    { baseURL: config.baseURL }
  );
};
